import * as React from "react";

import { side } from "../Component/components"
import { EntitetModellComponent } from "../Component/EntitetModellComponent"
import { horisontaltSkjema, feltVerdi } from "../Component/felt";
import { alleHandlinger } from "../Component/Handlinger"
import { ILoaderProps } from "../domene"

import Models = Gf.Web.Models;

export class Aktor extends EntitetModellComponent<Models.AktørFeltType, Models.AktørModell> {
    constructor(props: ILoaderProps) { super(props, "Aktor"); }

    renderWithModel(model: Models.AktørModell | undefined) {
        return side(`${feltVerdi(model, Models.AktørFeltType.Navn) || ""}`,
            <div>
                {alleHandlinger(model, this.getHandler(), handling => this.clientAction(handling))}
                {horisontaltSkjema(model, this.getHandler(),
                    Models.AktørFeltType.Navn,
                    Models.AktørFeltType.Epost,
                    Models.AktørFeltType.AktørType,
                    Models.AktørFeltType.Relasjon,
                    Models.AktørFeltType.RelasjonTil,
                    Models.AktørFeltType.Status,
                    )}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./Scripts/React/Aktor/Aktor.tsx